<template>
  <div
    class="container relative flex justify-between items-center mx-auto px-8 md:px-14 lg:px-24 w-full"
    data-aos="fade-up"
  >
    <section class="w-full">
      <div class="hidden md:block circle circle-2 absolute z-1"></div>
      <h2 class="secondary-title" id="project">My Projects</h2>
      <p class="section-paragraph">
        I did several projects during my spare times.
      </p>
      <!-- web -->
      <div
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img
              src="../assets/img/besmarLanding.webp"
              alt="image"
              class="w-full"
            />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  Besmart
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                A learning platform made to enhance students and teachers doing
                their activities in this era of the COVID-19 pandemic.
              </p>
              <div class="flex flex-wrap gap-1">
                <a
                  href=""
                  class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                  >tailwindcss</a
                >
                <a
                  href=""
                  class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                  >laravel</a
                >
                <a
                  href=""
                  class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                  >Javascript</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img src="../assets/img/bimbel.webp" alt="image" class="w-full" />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  e-bimbel
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-12">
                e bimble is made to make it easier for Database management
                system enhancement for users to process data on students and
                teachers who are learning and teaching, which is used to collect
                data
              </p>
              <div class="flex pb-1 gap-1">
                <a
                  href=""
                  class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                  >bootstrap</a
                >
                <a
                  href=""
                  class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                  >laravel</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img src="../assets/img/coffeeShop.webp" alt="image" class="w-full" />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  Senja Kopi
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                Enhances coffee shops to perform business marketing and make it
                easier for customers to find suitable coffee shops.
              </p>
              <div class="mb-2">
                <a
                  href=""
                  class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                  >tailwindcss</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img
              src="../assets/img/dashboardTrading.webp"
              alt="image"
              class="w-full"
            />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  Static Trade
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                a landing page used to monitor trading results and user activity
              </p>
              <div class="mt-24 flex gap-2">
                <a
                  href=""
                  class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                  >tailwindcss</a
                >
                <a
                  href=""
                  class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                  >laravel</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img src="../assets/img/heyevents.webp" alt="image" class="w-full" />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  HeyEvents
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                website to join and create ongoing events. Created for the
                purpose of entering the Dinacom 2022 app development
                competition.
              </p>
              <div class=" flex gap-2">
              <a
                href=""
                class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                >tailwindcss</a
              >
              <a
                href=""
                class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                >laravel</a
              >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- android -->
      <p class="text-xl font-bold" data-aos="fade-up" data-aos-duration="1000">
        Android
      </p>
      <div
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img
              src="../assets/img/besmartAndroid.webp"
              alt="image"
              class="w-full shadow-xl"
            />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  Besmart
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                this is the appearance of the besmart application in android
                view created for the final task
              </p>
              <div class="flex flex-wrap gap-1">
                <a
                  href=""
                  class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                  >tailwindcss</a
                >
                <a
                  href=""
                  class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                  >laravel</a
                >
                <a
                  href=""
                  class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                  >Javascript</a
                >
              </div>
            </div>
          </div>
        </div>

        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img
              src="../assets/img/lelangcengkeh.webp"
              alt="image"
              class="w-full shadow-xl"
            />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  LelangCengkeh
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                This application is made to do auctions held by the government
              </p>
              <div class="flex flex-wrap gap-1 mt-12">
                <a
                  href=""
                  class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                  >tailwindcss</a
                >
                <a
                  href=""
                  class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                  >laravel</a
                >
                <a
                  href=""
                  class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                  >Javascript</a
                >
                <a
                  href=""
                  class="px-3 py-1.5 rounded-lg bg-theme font-medium text-sm text-white"
                  >React</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- data science -->
      <p class="text-xl font-bold" data-aos="fade-up" data-aos-duration="1000">
        Data Science
      </p>
      <div
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img src="../assets/img/covid.webp" alt="image" class="w-full" />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  Covid-19
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                I made observations using the time series to predict how covid
                will be in the next year
              </p>
              <div class="flex justify-center">
                <a
                  href="https://colab.research.google.com/drive/1v9TCIFnkha8ZmVVjnwquchjprhkhGZou?usp=sharing"
                  target="_blank"
                  class="px-3 py-1.5 transition transform motion-reduce:transition-none motion-reduce:hover:transform-none hover:-translate-y-1 rounded-full border border-black font-medium text-sm hover:scale-110 hover:bg-theme hover:border-theme hover:text-white"
                  >View Project</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img src="../assets/img/titanic.webp" alt="image" class="w-full" />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  Titanic
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                Click to find out about how to boost machine learning accuracy,
                even with similar methods!
              </p>
              <div class="flex justify-center">
                <a
                  href="https://colab.research.google.com/drive/1pFptTxQERSteVQT4qF1Fqhrb_tDW-z-B?usp=sharing"
                  target="_blank"
                  class="px-3 py-1.5 transition transform motion-reduce:transition-none motion-reduce:hover:transform-none hover:-translate-y-1 rounded-full border border-black font-medium text-sm hover:scale-110 hover:bg-theme hover:border-theme hover:text-white"
                  >View Project</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img src="../assets/img/trace.webp" alt="image" class="w-full" />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  Trace Image with python
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                I created a program to quickly trace images by using the python
                programming language
              </p>
              <div class="flex justify-center">
                <a
                  href="https://github.com/muhBilal/trace-image"
                  target="_blank"
                  class="px-3 py-1.5 transition transform motion-reduce:transition-none motion-reduce:hover:transform-none hover:-translate-y-1 rounded-full border border-black font-medium text-sm hover:scale-110 hover:bg-theme hover:border-theme hover:text-white"
                  >View Project</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img src="../assets/img/ascii.webp" alt="image" class="w-full" />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  Convert Image to ASCII Python
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                I created a program to trace convert images to ascii code by
                using python
              </p>
              <div class="flex justify-center">
                <a
                  href=""
                  target="_blank"
                  class="px-3 py-1.5 transition transform motion-reduce:transition-none motion-reduce:hover:transform-none hover:-translate-y-1 rounded-full border border-black font-medium text-sm hover:scale-110 hover:bg-theme hover:border-theme hover:text-white"
                  >View Project</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img src="../assets/img/kidney.webp" alt="image" class="w-full" />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  Kidney Disease
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                This program I made to detect whether a person has chronic
                kidney failure by using the symptoms of symptoms he has, here
                <b>
                  <i> I get accuracy with data train 94% and test data 82% </i>
                </b>
              </p>
              <div class="flex justify-center">
                <a
                  href="https://colab.research.google.com/drive/1tY0jfVHg8ksXyxuZs43cPIlPHIrhRxAa?usp=sharing"
                  target="_blank"
                  class="px-3 py-1.5 transition transform motion-reduce:transition-none motion-reduce:hover:transform-none hover:-translate-y-1 rounded-full border border-black font-medium text-sm hover:scale-110 hover:bg-theme hover:border-theme hover:text-white"
                  >View Project</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img src="../assets/img/nilai.webp" alt="image" class="w-full" />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  Score Subject
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                By K-means, I clustered my classmates's academic performance
                just for fun! Hahaha!
              </p>
              <div class="flex justify-center">
                <a
                  href="https://drive.google.com/file/d/1xvNdCEx8X0AaA29OsEgnpUsoFjmyam0F/view?usp=sharing"
                  target="_blank"
                  class="px-3 py-1.5 transition transform motion-reduce:transition-none motion-reduce:hover:transform-none hover:-translate-y-1 rounded-full border border-black font-medium text-sm hover:scale-110 hover:bg-theme hover:border-theme hover:text-white"
                  >View Project</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img src="../assets/img/nilai.webp" alt="image" class="w-full" />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  Iris clustering
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                I grouped a dataset containing about irises by using clustering
                with the kmeans method
              </p>
              <div class="flex justify-center">
                <a
                  href="https://colab.research.google.com/drive/1EvZezUShOoJDgZOz7cDiTZjiu6n6k7r8#scrollTo=996CY7ePxru2"
                  target="_blank"
                  class="px-3 py-1.5 transition transform motion-reduce:transition-none motion-reduce:hover:transform-none hover:-translate-y-1 rounded-full border border-black font-medium text-sm hover:scale-110 hover:bg-theme hover:border-theme hover:text-white"
                  >View Project</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img src="../assets/img/iris.webp" alt="image" class="w-full" />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  Iris Classification
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                I have created a program to determine the type of iris using SVM
                and I got a score
                <b>test of 97% and train 99%.</b>
              </p>
              <div class="flex justify-center">
                <a
                  href="https://colab.research.google.com/drive/1TKNmWY_1IYWBm7HnIzTHKhV6I8aaQgSr#scrollTo=tRwP9vcgF7eK"
                  target="_blank"
                  class="px-3 py-1.5 transition transform motion-reduce:transition-none motion-reduce:hover:transform-none hover:-translate-y-1 rounded-full border border-black font-medium text-sm hover:scale-110 hover:bg-theme hover:border-theme hover:text-white"
                  >View Project</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img src="../assets/img/wheater.webp" alt="image" class="w-full" />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  Wheater Aus
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                I predicted the weather in Australia, up to a year ahead. Got
                90% accuracy!
              </p>
              <div class="flex justify-center">
                <a
                  href="https://colab.research.google.com/drive/172pckXzs-l4wi2lK2ekTO6GvUpPyOGVj"
                  target="_blank"
                  class="px-3 py-1.5 transition transform motion-reduce:transition-none motion-reduce:hover:transform-none hover:-translate-y-1 rounded-full border border-black font-medium text-sm hover:scale-110 hover:bg-theme hover:border-theme hover:text-white"
                  >View Project</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img src="../assets/img/pinguin.webp" alt="image" class="w-full" />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  Pinguin Classification
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                I created a program to detect including what kind of penguins,
                and here I get a score for the data
                <b>train of 99% and 100% for the test data</b>
              </p>
              <div class="flex justify-center">
                <a
                  href="https://colab.research.google.com/drive/1BRTb4e74zry3W7sTJQePbXFhUTWF6taU"
                  target="_blank"
                  class="px-3 py-1.5 transition transform motion-reduce:transition-none motion-reduce:hover:transform-none hover:-translate-y-1 rounded-full border border-black font-medium text-sm hover:scale-110 hover:bg-theme hover:border-theme hover:text-white"
                  >View Project</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="w-full px-4 text-black">
          <div class="bg-white rounded-lg overflow-hidden mb-10">
            <img src="../assets/img/boston.webp" alt="image" class="w-full" />
            <div class="p-8">
              <h3>
                <a
                  href="javascript:void(0)"
                  class="font-semibold text-dark text-xl sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px] mb-2 block hover:text-primary"
                >
                  Boston Housing
                </a>
              </h3>
              <p class="text-base text-body-color leading-relaxed mb-5">
                I created a program to predict the price of a house in Boston
                housing according to some of the conditions that affect the
                price of a housing. And here I get
                <b> 96% data train accuracy and 91% test data</b>
              </p>
              <div class="flex justify-center">
                <a
                  href="https://colab.research.google.com/drive/1cKwF1Dp7qtEU3YZV9eh25oi9nup45gzl"
                  target="_blank"
                  class="px-3 py-1.5 transition transform motion-reduce:transition-none motion-reduce:hover:transform-none hover:-translate-y-1 rounded-full border border-black font-medium text-sm hover:scale-110 hover:bg-theme hover:border-theme hover:text-white"
                  >View Project</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Project",
};
</script>
